<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES EN ORILLAS -->
    <img src="@/assets/monio.png" class="flor flor-lt" alt="Ornamento" loading="lazy" />
    <img src="@/assets/monio.png" class="flor flor-lb" alt="Ornamento" loading="lazy" />
    <img src="@/assets/monio.png" class="flor flor-rt" alt="Ornamento" loading="lazy" />
    <img src="@/assets/monio.png" class="flor flor-rb" alt="Ornamento" loading="lazy" />

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        :ref="el => { if (el) collageItems[index] = el }"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>

    <!-- MODAL TELETRANSPORTADO -->
    <Teleport to="body">
      <div
        v-if="isImageEnlarged"
        class="image-modal"
        @click="closeModal"
      >
        <img
          :src="images[currentIndex]"
          class="enlarged-image"
          alt="Imagen ampliada"
        />
      </div>
    </Teleport>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
      require('@/assets/30975_11zon.webp')
    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    let io = null

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      const flores = rootRef.value ? rootRef.value.querySelectorAll('.flor') : []
      const validItems = collageItems.value.filter(Boolean)

      // Asignación de estados iniciales ligeros acelerados por hardware
      gsap.set([bgRef.value, ...flores, ...validItems], {
        force3D: true
      })

      gsap.set(bgRef.value, { autoAlpha: 0 })
      gsap.set(flores, { autoAlpha: 0, y: 15 })
      gsap.set(validItems, { autoAlpha: 0, y: 20 })

      io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1. Revelado instantáneo de fondo
          tl.to(bgRef.value, {
            autoAlpha: 1,
            duration: 0.3
          })

          // 2. Revelado ágil de las imágenes
          .to(
            validItems,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.08
            },
            '-=0.2'
          )

          // 3. Revelado de flores decorativas
          .to(
            flores,
            {
              autoAlpha: 0.9,
              y: 0,
              duration: 0.4,
              stagger: 0.05
            },
            '-=0.3'
          )

          io.disconnect()
        })
      }, { threshold: 0.05 }) // Umbral ligero para respuesta inmediata al contacto

      if (rootRef.value) io.observe(rootRef.value)
    })

    onUnmounted(() => {
      if (io) io.disconnect()
    })

    return {
      images,
      rootRef,
      bgRef,
      collageItems,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: hidden;
  contain: content; /* Aísla pintura y cálculos de renderizado del documento */
}

/* FONDO ROSA */
.bg-rosa {
  position: absolute;
  inset: 0;
  background: #f0c9d3;
  z-index: 0;
  backface-visibility: hidden;
}

/* 🌸 FLORES */
.flor {
  position: absolute;
  width: 160px;
  max-width: 45vw;
  pointer-events: none;
  z-index: 1;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.flor-lt { top: -3vh; left: -45px; }
.flor-lb { bottom: 6vh; left: -55px; }
.flor-rt { top: -3vh; right: -45px; }
.flor-rb { bottom: 6vh; right: -55px; }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 6vh;
  padding-bottom: 6vh;
}

/* ITEM */
.collage-item {
  grid-column: span 12;
  cursor: pointer;
  margin-bottom: 4vh;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

/* IMAGEN */
.collage-image {
  width: 100%;
  display: block;
  object-fit: contain;
  content-visibility: auto;
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  backface-visibility: hidden;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  object-fit: contain;
}

/* ===== Rasgados ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  z-index: 12;
  pointer-events: none;
}

.rasgado-inferior {
  bottom: 0;
  background: #f0c9d3;
  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
}
</style>